import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RaLoadingComponent } from '@shared/components';
import { CoverComponent } from './cover.component';

@NgModule({
    declarations: [CoverComponent],
    imports: [CommonModule, RaLoadingComponent],
    exports: [CoverComponent],
})
export class CoverModule {}
